import gsap from 'gsap';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

export default class Cursor {
  constructor() {
    this.targetX = 0;
    this.targetY = 0;

    this.slowX = 0;
    this.slowY = 0;

    this.fastX = 0;
    this.fastY = 0;

    this.dot = document.querySelector('.a-pointer-dot');
    this.label = document.querySelector('.a-pointer-label');
    this.circle = document.querySelector('.a-pointer-circle');

    this.cta = document.querySelectorAll('.p-cta');
    this.indicator = document.querySelector('.i-indicator');
    this.svg = document.querySelectorAll('.a-pointer-circle circle');
  }

  run = () => {
    this.slowX += ((this.targetX - this.slowX) * 0.07);
    this.slowY += ((this.targetY - this.slowY) * 0.07);

    this.fastX += ((this.targetX - this.fastX) * 0.14);
    this.fastY += ((this.targetY - this.fastY) * 0.14);

    this.dot.style.transform = `translate3d(${this.fastX}px, ${this.fastY}px, 0)`;
    this.label.style.transform = `translate3d(${this.fastX}px, ${this.fastY}px, 0)`;
    this.circle.style.transform = `translate3d(${this.slowX}px, ${this.slowY}px, 0)`;
  }

  mouseEnter = () => {
    gsap.to(this.svg, {
      scale: 1.7,
      duration: 0.3,
      transformOrigin: 'center center',
    });
  }

  mouseLeave = () => {
    gsap.to(this.svg, {
      scale: 1,
      duration: 0.3,
      transformOrigin: 'center center',
    });
  }

  removeEvents = () => {
    [...this.cta].forEach((el) => {
      el.removeEventListener('mouseenter', this.mouseEnter);
      el.removeEventListener('mouseleave', this.mouseLeave);
    });

    this.cta = undefined;
  }

  resetEvents = () => {
    this.cta = document.querySelectorAll('.p-cta');

    [...this.cta].forEach((el) => {
      el.addEventListener('mouseenter', this.mouseEnter);
      el.addEventListener('mouseleave', this.mouseLeave);
    });
  }

  addEvents = () => {
    window.addEventListener('mousemove', (e) => {
      this.targetX = e.clientX;
      this.targetY = e.clientY;
    });

    [...this.cta].forEach((el) => {
      el.addEventListener('mouseenter', this.mouseEnter);
      el.addEventListener('mouseleave', this.mouseLeave);
    });
  }

  reset = () => {
    this.removeEvents();
    this.resetEvents();
  }

  init = () => {
    this.addEvents();

    gsap.ticker.add(this.run);

    gsap.set(this.indicator, {
      scale: 1,
      drawSVG: '0% 0%',
      transformOrigin: 'center center',
    });
  }
}
